import React from 'react'
import ChangelogContainer from './components/ChangelogContainer'
import ErrorBoundary from './components/ErrorBoundary'
import { ReactChangelogProps } from './types'
import { useTheme } from './hooks/useTheme'
import './tw.scss'

const ReactChangelog: React.FC<ReactChangelogProps> = React.memo(
  ({
    endpoint,
    data,
    className = '',
    showFilters = true,
    showScrollToVersion = true,
    title,
    theme,
    admin = false,
  }) => {
    // Helpers to detect user's OS mode, using window func instead of useMediaQuery cannot be called at the top level
    const mQ = window.matchMedia('(prefers-color-scheme: dark)')

    const darkMode = () => {
      return mQ.matches
    }
    const themeDeterminer = () => {
      if (!theme) {
        if (darkMode()) {
          return 'dark'
        }
        return 'light'
      }
      return theme
    }
    const { appliedTheme, themeClass } = useTheme(themeDeterminer())

    return (
      <ErrorBoundary>
        <div
          className={`react-changelog-container ${themeClass} ${className} w-full h-full`}
          data-theme={appliedTheme}
          style={{
            backgroundColor: 'var(--changelog-bg)',
            color: 'var(--changelog-text)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <ChangelogContainer
            endpoint={endpoint}
            data={data}
            showFilters={showFilters}
            showScrollToVersion={showScrollToVersion}
            title={title}
            admin={admin}
          />
        </div>
      </ErrorBoundary>
    )
  },
)

ReactChangelog.displayName = 'ReactChangelog'

export default ReactChangelog
